import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {sendSMS, resetSendSMS, reseGetContactsStatus} from "../../store/reducers/ContactsSlice";
import {RequestStatus} from "../../utils/Enums";
import {Option} from "../common/form/ElogSelect";
import {getSMSSenders} from "../../store/reducers/SMSSendersSlice";

interface SendSMSStep3Props {
}

export const SendSMSStep3: React.FC<SendSMSStep3Props> = () => {

    const dispatch = useAppDispatch();

    const contactsState = useAppSelector((state) => state.contacts);
    const sendersState = useAppSelector(state => state.SMSSenders);

    const [content, setContent] = useState<string>("");
    const [success, setSuccess] = useState<boolean>(false);
    const [selectedSender, setSelectedSender] = useState<string>("");

    const sendSMSStatus = contactsState.sendSMSStatus;

    useEffect(() => {
        dispatch(getSMSSenders());
    }, [])

    useEffect(() => {
        if ( sendersState.SMSSenders.length > 0 ) {
            setSelectedSender(String(sendersState.SMSSenders[0].id));
        }
    }, [sendersState.SMSSenders])

    useEffect(() => {

        if ( sendSMSStatus === RequestStatus.Success ) {
            setSuccess(true);
            dispatch(resetSendSMS());
        }

    },[sendSMSStatus])

    const handleButtonClick = (text: string) => {
        const textarea = document.getElementById("wysiqyg") as HTMLTextAreaElement;
        const { selectionStart, selectionEnd } = textarea;
        const newContent =
            content.substring(0, selectionStart) +
            text +
            content.substring(selectionEnd, content.length);
        setContent(newContent);
        textarea.focus();
        textarea.setSelectionRange(selectionStart + text.length, selectionStart + text.length);
    };

    const send = () => {
        dispatch(sendSMS({ content, sender: selectedSender }));
    }

    const handleContentButton = () => {
        setContent(content + "[contact]");
    };

    const handleSenderChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedSender(event.target.value);
    };

    const senderOptions: Option[] = sendersState.SMSSenders
        .map((sender) => ({
            value: sender.id.toString(),
            label: `${sender.name}`,
        }));

    return (
        <LoggedInView fullWidth={false}>
            <h1>Saada E-mail</h1>
            {success && <div className="message msg-ok">
              <div>
                <h2>SMSid saadetud</h2>
              </div>
            </div>}
            {!success &&
            <div className="form">
              <form method="post">
                <h2><span>Saada SMS</span></h2>
                <table className="form">
                  <tbody>
                  <tr>
                    <th>Adressaadid:</th>
                    <td>
                        {contactsState?.contacts?.map((contact) => (
                            <React.Fragment key={contact.id}>
                                <strong>{contact.name}</strong> - {contact.name} (
                                {contact.phone})<br/>
                            </React.Fragment>
                        ))}
                    </td>
                  </tr>
                  <tr>
                    <th>Saatja:</th>
                    <td>
                      <select
                        name="sender"
                        id="sender"
                        value={selectedSender}
                        onChange={handleSenderChange}
                      >
                          {senderOptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                  {option.label}
                              </option>
                          ))}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <th>Sisu:</th>
                    <td>
                      <input
                        type="text"
                        id="contact_name"
                        name="subject"
                        className="text"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                      />
                      <input
                        type="button"
                        onClick={handleContentButton}
                        value="[contact]"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <td>
                      <div className="action clear">
                        <p>
                          <button type="button" onClick={send}>
                      <span>
                        <strong>Saada </strong>
                      </span>
                          </button>
                        </p>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </form>
            </div>
            }
        </LoggedInView>
    );

}